// Import reducers from each module's deep `src/store` path — never the module barrel.
// The module barrels (`@cobliteam/costs`, `@cobliteam/tracking`, ...) also `export default <Page>`,
// which under Rollup drags the entire page tree into this entry chunk via side-effect binding
// (modules have no `sideEffects: false`). Deep-import keeps the reducers isolated.
import { costsReducer } from '@cobliteam/costs/src/store';
import { deviceConfigurationReducer } from '@cobliteam/device-configuration/src/store';
import { pastMaintenancesReducer, registerMaintenanceReducer, upcomingMaintenancesReducer } from '@cobliteam/maintenance/src/store';
import { routingReducer as newRoutingReducer, routesReducer } from '@cobliteam/routing/src/store';
import { routeHistoryReducer, trackingReducer } from '@cobliteam/tracking/src/store';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { alarmsReducer } from './Alarms';
import { devicesReducer } from './Devices';
import { disablerReducer } from './Disabler';
import { driversReducer } from './Drivers';
import { fleetReducer } from './Fleet';
import { geocodeReducer } from './Geocode';
import { geofenceFormReducer } from './GeofenceForm';
import { geofenceTabReducer } from './Geofences';
import { geofencesTabReducer } from './GeofenceTab';
import { spreadsheetReducer } from './HOR';
import { history } from './history';
import { invitesReducer } from './Invites';
import { mapReducer } from './Map';
import { passwordReducer } from './Password';
import { reportsReducer } from './Performance';
import { popupReducer } from './Popup';
import { usersReducer } from './Users';
import { vehiclePopupReducer } from './VehiclePopup';
import { vehiclesReducer } from './Vehicles';
import { vehiclesTabReducer } from './VehiclesTab';

const rootStoreReducer = combineReducers({
  alarms: alarmsReducer,
  costs: costsReducer,
  devices: devicesReducer,
  disabler: disablerReducer,
  drivers: driversReducer,
  fleet: fleetReducer,
  geocode: geocodeReducer,
  geofenceForm: geofenceFormReducer,
  geofences: geofenceTabReducer,
  geofenceTab: geofencesTabReducer,
  invites: invitesReducer,
  map: mapReducer,
  newRouting: newRoutingReducer,
  password: passwordReducer,
  pastMaintenances: pastMaintenancesReducer,
  popup: popupReducer,
  registerMaintenance: registerMaintenanceReducer,
  reportsPerformance: reportsReducer,
  router: connectRouter(history),
  routes: routesReducer,
  routesHistory: routeHistoryReducer,
  spreadsheet: spreadsheetReducer,
  tracking: trackingReducer,
  upcomingMaintenances: upcomingMaintenancesReducer,
  users: usersReducer,
  vehiclePopup: vehiclePopupReducer,
  vehicles: vehiclesReducer,
  vehiclesTab: vehiclesTabReducer,
  deviceConfiguration: deviceConfigurationReducer,
});

export { rootStoreReducer };
